export default {
  install(Vue, options) {
    Vue.prototype.$LeafletMap = {
      FMap:'',
      FLayer:'',
      OSMUrl:'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      latlngs:[],
      HistoryTracelatlngs:[],
      DistanceMarkerGroup:[],
      UnitMarkerGroup:[],
      HistoryMarkerGroup:[],
      CameraMarkerGroup:[],
      CameraMarkers:[],
      HistoryUnitMarker:'',
      LFDistancemarkers:[],
      LFUnitMarkers:[],
      LFHistoryMarkers:[],
      KmArr:[],
      MiArr:[],
      KmTotal:[],
      MiTotal:[],
      IsClick:false,
      PolySwitchClick:false,
      MarkerIcon:'',
      MapclickListen:false,
      polyline:[],
      Historypolyline:[],
      Tag:'',
      bounds:'',
      markers:[],
      ciLayer:'',
      AccOnOffmarkers:[],
      AccOnOffciLayer:'',
      POImarkers:[],
      POIsrc:'',
      POIMarkerGroup:[],
      Circles:'',
      Polygons:'',
      CircleArr:[],
      PolygonArr:[],
      //OSMUrl:'../static/Tiles/{z}/{x}/{y}.png',
      //地圖初始化
      InitMap:function (Tag, Latitude, Longitude, Zoom) {
        this.Tag = Tag
        this.FMap = L.map(Tag, {
          fullscreenControl: true,
          fullscreenControlOptions: {
            position: 'topright'
          }
        });
        this.FMap.setView(new L.LatLng(Latitude, Longitude), Zoom);
        this.FLayer = new L.TileLayer(this.OSMUrl, {
            maxZoom: 19,
            maxNativeZoom: 19,
        });
        this.FMap.addLayer(this.FLayer);
        this.POIMarkerGroup = L.layerGroup().addTo(this.FMap)//重新建立一個空的POIMarkerLayer
        this.UnitMarkerGroup = L.layerGroup().addTo(this.FMap)//重新建立一個空的UnitMarkerLayer
        this.HistoryUnitMarker = L.layerGroup().addTo(this.FMap)//重新建立一個空的HistoryUnitMarker
        this.HistoryUnitMarker.setZIndex(2)
        this.HistoryMarkerGroup = L.layerGroup().addTo(this.FMap)//重新建立一個空的HistoryMarkerGroup
        this.HistoryMarkerGroup.setZIndex(1)
        this.CameraMarkerGroup = L.layerGroup().addTo(this.FMap)//重新建立一個空的CameraMarkerGroup
        setTimeout(() => {
          this.FMap.invalidateSize();
        }, 300);
        //讀取kml
        // var kmlLayer;
        // var this_ = this;
        // Vue.prototype.$axios.get('../static/KML/Water Pipes.kml').then(function (response) {
        //     let bounds;
        //     let data = response.data;
        //     const parser = new DOMParser();
        //     const kmlData = parser.parseFromString(data, 'text/xml');  // 解析KML
            
        //     kmlLayer = new L.KML(kmlData);  // KML套疊
        //     this_.FMap.addLayer(kmlLayer);
        //     bounds = kmlLayer.getBounds();  // zoom至KML範圍
        //     this_.FMap.fitBounds(bounds);
        // });
      },
      //新增 啟動熄火點位 圖層
      AddAccOnOffciLayer(){
        this.AccOnOffciLayer = L.canvasIconLayer({}).addTo(this.FMap);
        this.AccOnOffciLayer.addOnClickListener(function (e,data) {
          Vue.prototype.$History.HistoryCurrentNum = data[0].data.index+1
        });
        // console.log(this.AccOnOffmarkers)
        this.AccOnOffciLayer.addLayers(this.AccOnOffmarkers);
        //調整地圖 才不會沒渲染到
        setTimeout(() => {
          this.SetCenter(this.FMap.getCenter().lat-0.0001,this.FMap.getCenter().lng,this.FMap.getZoom())
          setTimeout(() => {
            this.SetCenter(this.FMap.getCenter().lat+0.0001,this.FMap.getCenter().lng,this.FMap.getZoom())
          }, 100);
        }, 100);
      },
      //刪除 啟動熄火點位 圖層
      RemoveAccOnOffciLayer(){
        for(var i =0 ; i<this.AccOnOffmarkers.length;i++){
          this.AccOnOffciLayer.removeMarker(this.AccOnOffmarkers[i],false)
        }
        //調整地圖 才不會沒渲染到
        setTimeout(() => {
          this.SetCenter(this.FMap.getCenter().lat-0.0001,this.FMap.getCenter().lng,this.FMap.getZoom())
          setTimeout(() => {
            this.SetCenter(this.FMap.getCenter().lat+0.0001,this.FMap.getCenter().lng,this.FMap.getZoom())
          }, 100);
        }, 100);
      },
      //新增 歷史軌跡箭頭圖層
      AddciLayer(){
        this.ciLayer = L.canvasIconLayer({}).addTo(this.FMap);
        this.ciLayer.addOnClickListener(function (e,data) {
          Vue.prototype.$History.HistoryCurrentNum = data[0].data.index+1
        });
        // this.ciLayer.addOnHoverListener(function (e,data) {
        //   console.log(data[0].data._leaflet_id)
        // });
        this.ciLayer.addLayers(this.markers);
        setTimeout(() => {
          this.SetCenter(this.FMap.getCenter().lat-0.0001,this.FMap.getCenter().lng,this.FMap.getZoom())
        }, 100);
      },
      //刪除 歷史軌跡箭頭圖層
      RemoveciLayer(){
        for(var i =0 ; i<this.markers.length;i++){
          this.ciLayer.removeMarker(this.markers[i],false)
        }
        //刪除要refersh
        setTimeout(() => {
          this.SetCenter(this.FMap.getCenter().lat-0.0001,this.FMap.getCenter().lng,this.FMap.getZoom())
        }, 100);
      },
      //多車鎖定
      Multifocus: function (WatchUnitsLatLng) {
        if(WatchUnitsLatLng.length != 0){
          this.bounds = []
          for (var i = 0; i < WatchUnitsLatLng.length; i++) {
            this.bounds.push([WatchUnitsLatLng[i].latitude, WatchUnitsLatLng[i].longitude]);
          }
          this.FMap.fitBounds(this.bounds,{padding: [40,40]});
        }
      },
      //latlng array fitbounds
      fitBounds(bounds){
        this.FMap.fitBounds(bounds,{padding: [40,40]});
      },
      //設定地圖中心
      SetCenter:function(Lat,Lng,Zoom){
        this.FMap.setView(new L.LatLng(Lat, Lng), Zoom)
      },
      //新增地圖click事件
      AddMapclickListen:function(){
        var this_=this
        this.FMap.on('click', function(e) {//Map Click Listenner // Add Marker and PolyLine
          if(!this_.IsClick){
            this_.IsClick =true
            //console.log(e.latlng)
            var popLocation= e.latlng;
            this_.Addpolyline(popLocation)//加入polyline
            this_.CalculateKmMi()//計算新的經緯度距離
            this_.AddMarker(popLocation,this_.latlngs.length-1,'DistanceMarker')//將Marker Div加入
            setTimeout(() => {
              this_.IsClick =false
            }, 250);
          }  
        });
      },
      //新增量測距離點位
      AddDistanceMark(index){
        var Show = '' 
        switch (localStorage.getItem('Unit')) {
          case 'km':
            Show = this.KmArr[index]+Vue.prototype.$Global.Unit+'<br/>'+this.KmTotal[index]+Vue.prototype.$Global.Unit
            break;
          case 'mi':
            Show = this.MiArr[index]+Vue.prototype.$Global.Unit+'<br/>'+this.MiTotal[index]+Vue.prototype.$Global.Unit
              break;        
          default:
            break;
        }
        this.MarkerIcon = L.divIcon({//Add map divIcon
          html:'<img class="DistanceMarkericoncalss" src="'+require('../static/images/GoogleMapICON/Row1/green-dot.png')+'">'+
          '<div class="px-1 kmmishowdiv" >'+Show+'</div>'
        });
      },
      //新增車機點位
      AddUnitMarker(MarkerObj){
        var dotcolor = ''
        if(MarkerObj.connectionState == 0){
          dotcolor = 'style="border-color:red !important"'
        }else{
          switch (MarkerObj.accState) {
            case 0:
              dotcolor = 'style="border-color:blue !important"'
              break;
            case 1:
              dotcolor = 'style="border-color:green !important"'
              if(MarkerObj.State){
                if(MarkerObj.State == 'Idle'){
                  dotcolor = 'style="border-color:#FF8429 !important"'
                }
              }
              break;        
            default:
              break;
          }
        }
        this.MarkerIcon = L.divIcon({//Add map divIcon
          html:
          `
          <div id="CarNo_`+MarkerObj.unitId+`" class="Markericoncalss" style="position:relative">
            <div id="dot`+MarkerObj.unitId+`" class="dot" `+dotcolor+`></div>
            <img title="`+MarkerObj.identifier+`" style="position:absolute;top:0;left:0;z-index: 1;" src=`+MarkerObj.UnitImgGroup.Unitimg+`>
          </div>
          `
        });
        this.AddUnitMarkEvent("CarNo_"+MarkerObj.unitId,MarkerObj)
      },
      // AddHistoryMMarker(MarkerObj,index){
      //   var id = 'HistoryMarker'+ MarkerObj.positionLogId
      //   switch (MarkerObj.color) {
      //     case 'red':
      //       MarkerObj.colornum = '6'
      //       break;
      //     case 'orange':
      //       MarkerObj.colornum = '5'
      //       break; 
      //     case 'green':
      //       MarkerObj.colornum = '1'
      //       break;               
      //     default:
      //       break;
      //   }
      //   this.MarkerIcon = L.divIcon({//Add map divIcon
      //     html: `<div id="HistoryMarker" style="background-color:transparent;height:10px;width:10px;border-radius:10px;position:relative;"><img src="../static/images/MapIcon/Arrow/CHeadN_s`+MarkerObj.colornum+`.gif" id="`+id+`" style="position:absolute;top:-7.5px;left:-7.5px;transform:rotate(`+MarkerObj.direction+`deg)"></div>`
      //   });
      //   this.AddHistoryMarkerEvent(id,index)
      // },
      // AddHistoryMarkerEvent(id,index){
      //   setTimeout(() => {
      //     Vue.prototype.$("#"+id).click(function(){
      //       Vue.prototype.$History.HistoryCurrentNum = index+1
      //     })
      //   }, 20);
      // },
      //新增歷史軌跡camera點位
      AddCameraMMarker(MarkerObj){
        var Camera = ``
        var id= `EventVideo`+MarkerObj.positionLogId
        Camera =  `<div title="Event Video"><i id="`+id+`" class="fa fa-camera CameraColor" style="font-size:20px;position:absolute;top:-35px;left:-5px;cursor:pointer;z-index:100"></i></div>`
        this.MarkerIcon = L.divIcon({//Add map divIcon
          html: Camera
        });
        this.AddCameraMarkerEvent(id,MarkerObj)
      },
      //新增歷史軌跡車機點位
      AddHistoryUnitMarker(MarkerObj){
        var colornum;
        switch (MarkerObj.color) {
          case 'red':
            colornum = 6
            break;
          case 'green':
            colornum = 1
            break;       
          case 'orange':
            colornum = 5
            break;
          default:
            colornum =1
            break;
        }
        var objectIconPath =MarkerObj.objectIconPath
        if(objectIconPath != undefined){
          switch (objectIconPath.toLowerCase()) {
            case 'cars':
                objectIconPath = 'Car'
              break;
            case 'ambulance':
                objectIconPath = 'ambulance'
                break;
            case 'bus':
                objectIconPath = 'bus'
                break;
            case 'bus2':
                objectIconPath = 'bus2'
                break;
            case 'dumptruck':
                objectIconPath = 'DumpTruck'
                break;
            case 'excavator':
                objectIconPath = 'Excavator'
                break;
            case 'freightliner':
                objectIconPath = 'Freightliner'
                break; 
            case 'grader':
                objectIconPath = 'grader'
                break;
            case 'motorGrader':
                objectIconPath = 'MotorGrader'
                break; 
            case 'people':
                objectIconPath = 'people'
                break; 
            case 'plate':
                objectIconPath = 'Plate'
                break; 
            case 'motocycle':
                objectIconPath = 'Scooter'
                break;  
            case 'trailer':
                objectIconPath = 'trailer'
                break;  
            case 'truck':
                objectIconPath = 'Truck'
                break;        
            default:
                break;
          }
        }
        // console.log(objectIconPath)
        var directionindex = Vue.prototype.$Global.DegreeDirection(MarkerObj.direction)
        this.MarkerIcon = L.divIcon({//Add map divIcon
          html: `
          <div id="HistoryUnitMarker" class="Markericoncalss" style="position:relative">
            <img  title="`+MarkerObj.identifier+`" style="z-index: 1;position: relative;" src=`+require('../static/images/MapIcon/'+objectIconPath+'/CHead'+directionindex+'_S'+colornum+'.gif')+`>
          </div>
          `
        });
        //控制HistoryMarker在最上層
        // setTimeout(() => {
        //   this.SetHistoryMarkerZ_Index()
        // }, 1);
      },
      // SetHistoryMarkerZ_Index(){
      //   var parent = Vue.prototype.$("#HistoryUnitMarker").parent()
      //   parent.css('z-index',1)
      //   var Traceparent = Vue.prototype.$("#HistoryMarker").parent()
      //   Traceparent.css('z-index',2)
      //   // var Traceparentzindex = Traceparent.css('z-index')
      // },
      //新增歷史軌跡camera click 事件
      AddCameraMarkerEvent(HistoryMarkeid,HistoryMarkerObj){
        setTimeout(() => {
          Vue.prototype.$("#"+HistoryMarkeid).click(function(){
            // console.log('123456789')
            //4channel的時候要改
            for(var i = 1 ; i <=16 ; i++){
              if(HistoryMarkerObj['upload'+i] == undefined){
                break;
              }else if(HistoryMarkerObj['upload'+i] != 0){
                // console.log('upload'+i)
                // console.log(HistoryMarkerObj['upload'+i])
                Vue.prototype.$History.OpenEventVideo(HistoryMarkerObj,i-1)
              }
            }
            // if(HistoryMarkerObj.upload1 !=0){
            //   Vue.prototype.$Vehicle.OpenEventVideo(HistoryMarkerObj,0)
            // }
            // if(HistoryMarkerObj.upload2 !=0){
            //   Vue.prototype.$Vehicle.OpenEventVideo(HistoryMarkerObj,1)
            // }
          })
        }, 100);
      },
      //新增追蹤 車機 click 事件
      AddUnitMarkEvent(UnitMarkID,MarkerObj){
        var this_ = this
        setTimeout(() => {
          //紀錄點選車機資訊
          Vue.prototype.$("#"+UnitMarkID).click(function(){
            Vue.prototype.$Vehicle.ClickUnitInfo = MarkerObj
            // Vue.prototype.$Vehicle.setUnitVideoShow()
            // Vue.prototype.$Vehicle.setCameraConnection()
            if(MarkerObj.unitId != Vue.prototype.$Vehicle.ClickUnitInfo.unitId){
              Vue.prototype.$Vehicle.CloseVideo()
            }
            Vue.prototype.$Vehicle.UnitListDetailShow = true//打開UnitDetail
            this_.SetCenter(MarkerObj.latitude,MarkerObj.longitude,Vue.prototype.$Global.FocusZoom)
            setTimeout(() => {
              this_.SetUnitmarkZindex(MarkerObj.unitId)
            }, 250);
            Vue.prototype.$Global.SetDotOn(MarkerObj.unitId)
            if(Vue.prototype.$Global.FreeMode != 'true'){
              //切換為自由模式
              Vue.prototype.$Global.FreeMode='true'
              setTimeout(() => {
                //解除自由模式
                Vue.prototype.$Global.FreeMode = 'false'
              }, 10000);
            }
            // if(localStorage.getItem('MultiFocusUnitTimeoutID')!=''){
            //   Vue.prototype.$Global.ClearMultiFocusStartMultiFocus()
            // }
          })
        }, 20);
      },
      // 控制地圖車機移動至最上層
      SetUnitmarkZindex(UnitID){
        Vue.prototype.$('.leaflet-marker-icon').css('z-index',500)
        var parent = Vue.prototype.$("#CarNo_"+UnitID).parent()
        var parentzindex = parent.css('z-index')
        parent.css('z-index',parentzindex*10)
        Vue.prototype.$Vehicle.ClickUnitID = UnitID
      },
      //新增POI點位
      AddPOIMark(Obj){
        if(this.POIsrc == ''){
          return
        }
        var MarkerIcon = L.divIcon({//Add map divIcon
          html:'<img class="POIMarkericoncalss" src="'+this.POIsrc+'">'+
          '<div class="px-1 pointNamediv" >'+Obj.pointName+'</div>'
        });
        var LFmarker = L.marker([Obj.centerY,Obj.centerX],{
          icon: MarkerIcon,
        })
        LFmarker.addTo(this.POIMarkerGroup);
        this.POImarkers.push(LFmarker)
      },
      //新增點位 打點function
      AddMarker(MarkerObj,index,Type){
        switch (Type) {
          case'HistoryACCOnOffMarker':
            var color =''
            if(MarkerObj.reportId == 11){
              switch (MarkerObj.accState) {
                case true:
                  // console.log('ACC On')
                  // this.AccOnOffciLayer
                  color = 'green'
                  break;
                case false:
                  // console.log('ACC Off')
                  // this.AccOnOffciLayer
                  color = 'blue'
                  break;            
                default:
                  break;
              }
            }else{
              color = 'red'
            }
            //標點icon
            var icon = L.icon({
              iconUrl: require('../static/images/GoogleMapICON/Row2/'+color+'.png'),
              iconSize: [32, 32],
              iconAnchor: [16, 32],
            });
            var LFmarker = L.marker([MarkerObj.latitude,MarkerObj.longitude],{
              icon: icon,
            })
            LFmarker.index = index
            this.AccOnOffmarkers.push(LFmarker)
            break;
          case 'DistanceMarker':
            this.AddDistanceMark(index)
            var LFmarker = L.marker([MarkerObj.lat,MarkerObj.lng],{icon: this.MarkerIcon})
            LFmarker.addTo(this.DistanceMarkerGroup);
            this.LFDistancemarkers.push(LFmarker)//紀錄目前Marker
            break;
          case 'UnitMarker':
            this.AddUnitMarker(MarkerObj)
            var LFmarker = L.marker([MarkerObj.latitude,MarkerObj.longitude],{icon: this.MarkerIcon})
            LFmarker.addTo(this.UnitMarkerGroup);
            this.LFUnitMarkers.push(LFmarker)//紀錄目前Marker
            break;
          case 'HistoryMarker':
            // console.log(MarkerObj.arrowColor)
            // this.AddHistoryMMarker(MarkerObj,index)
            switch (MarkerObj.arrowColor) {
              case 'red':
                MarkerObj.colornum = '6'
                break;
              case 'orange':
                MarkerObj.colornum = '5'
                break; 
              case 'green':
                MarkerObj.colornum = '1'
                break;
              case 'yellow':
                MarkerObj.colornum = '4' 
                break;
              default:
                break;
            }
            var directionindex = Vue.prototype.$Global.DegreeDirection(MarkerObj.direction)
            //箭頭icon
            var icon = L.icon({
              iconUrl: require('../static/images/MapIcon/Arrow/CHead'+directionindex+'_s'+MarkerObj.colornum+'.gif'),
              iconSize: [25, 23],
              iconAnchor: [10, 9],
            });
            var LFmarker = L.marker([MarkerObj.latitude,MarkerObj.longitude],{
              icon: icon,
            })
            // LFmarker.options.icon.style.WebkitTransform = LFmarker.options.icon.style.WebkitTransform + ' rotate(' + LFmarker.options.iconAngle + 'deg)';
            // LFmarker.options.icon.style.MozTransform = 'rotate(' + LFmarker.options.iconAngle + 'deg)';
            LFmarker.index = index
            this.markers.push(LFmarker)
            // LFmarker.addTo(this.HistoryMarkerGroup);
            // this.LFHistoryMarkers.push(LFmarker)//紀錄目前Marker
            break;
          case 'HistoryUnitMark':
            Vue.prototype.$(".leaflet-marker-icon").css('z-index',0)
            this.AddHistoryUnitMarker(MarkerObj)
            var LFmarker = L.marker([MarkerObj.latitude,MarkerObj.longitude],{icon: this.MarkerIcon})
            LFmarker.addTo(this.HistoryUnitMarker);
            break;
          case 'CameraMarker':
            this.AddCameraMMarker(MarkerObj)
            var LFmarker = L.marker([MarkerObj.latitude,MarkerObj.longitude],{icon: this.MarkerIcon})
            LFmarker.addTo(this.CameraMarkerGroup);
            this.CameraMarkers.push(LFmarker)//紀錄目前Marker
            break;   
          default:
            break;
        }
      },
      // removeMe(id,Group,Object) {//刪除單一Marker
      //   Object = []
      //   Group.eachLayer(function (layer) {
      //     if (layer._leaflet_id === id){
      //       Group.removeLayer(layer)
      //     }else{
      //       Object.push(layer)
      //     }
      //   });	
      // },
      //刪除POI
      RemovePOIMarkerGroup:function(){
        this.FMap.removeLayer(this.POIMarkerGroup)
        this.POImarkers = []//刪除目前所有Marker
        this.POIMarkerGroup = L.layerGroup().addTo(this.FMap)//重新建立一個空的MarkerLayer
      },
      //刪除量測距離
      RemoveDistanceMarkerGroup:function(){
        this.FMap.removeLayer(this.DistanceMarkerGroup)
        this.LFDistancemarkers = []//刪除目前所有Marker
      },
      //刪除車機
      RemoveUnitMarkerGroup:function(){
        if(this.UnitMarkerGroup.length !=0){
          this.FMap.removeLayer(this.UnitMarkerGroup)
          this.LFUnitMarkers= []//刪除目前所有UnitMarker
          this.UnitMarkerGroup = L.layerGroup().addTo(this.FMap)//重新建立一個空的MarkerLayer
        }
      },
       //刪除歷史軌跡箭頭
      RemoveHistoryMarkerGroup:function(){
        if(this.HistoryMarkerGroup.length !=0){
          this.FMap.removeLayer(this.HistoryMarkerGroup)
          this.LFHistoryMarkers= []//刪除目前所有HistoryMarker
          this.HistoryMarkerGroup = L.layerGroup().addTo(this.FMap)//重新建立一個空的MarkerLayer
          this.HistoryMarkerGroup.setZIndex(1)
        }
      },
      //刪除歷史軌跡camera
      RemoveCameraMarkerGroup:function(){
        if(this.CameraMarkerGroup.length !=0){
          this.FMap.removeLayer(this.CameraMarkerGroup)
          this.CameraMarkers= []//刪除目前所有CameraMarker
          this.CameraMarkerGroup = L.layerGroup().addTo(this.FMap)//重新建立一個空的MarkerLayer
        }
      },
      //刪除里史軌跡車機
      RemoveHistoryUnitMarker:function(){
        this.FMap.removeLayer(this.HistoryUnitMarker)
        this.HistoryUnitMarker = L.layerGroup().addTo(this.FMap)
        this.HistoryUnitMarker.setZIndex(2)
      },
       //刪除量測距離polyline 及 初始畫相關array
      RemoveDistance:function(){
        this.RemoveclickListen()
        this.RemoveDistanceMarkerGroup()
        this.Deletepolyline()
        this.Removepolyline()
        this.KmArr = []
        this.MiArr = []
        this.KmTotal = []
        this.MiTotal = []
      },
      //刪除地圖click 事件
      RemoveclickListen:function(){
        this.FMap.off('click')
      },
      //新增polyline
      Addpolyline:function(latlng){
        this.latlngs.push(latlng)//將新的經緯度加進去
        this.Deletepolyline()//刪除之前的polyline
        this.polyline = L.polyline(this.latlngs, {color: 'blue'});//新增新的polyline
        this.polyline.addTo(this.FMap)//加入新的polyline
        // zoom the map to the polyline
      },
      //刪除歷史軌跡polyline
      RemoveHistoryTraceline:function(){
        this.DeleteHistorypolyline()
        this.HistoryTracelatlngs = []
      },
      //新增歷史軌跡線
      AddHistoryTraceline:function(Obj){
        //console.log(Obj)
        this.RemoveCameraMarkerGroup()
        for(var i=0 ; i<Obj.length ;i++){
          this.HistoryTracelatlngs.push({lat:Obj[i].latitude,lng:Obj[i].longitude})
          //4channel的時候要改
          // if(Vue.prototype.$Global.authorityDefine['VD00']){
          //   for(var j = 1 ; j <=16 ; j++){
          //     if(Obj[i]['upload'+j] == undefined){
          //       break;
          //     }else if(Obj[i]['upload'+j] != 0){
          //       this.AddMarker(Obj[i],i,'CameraMarker')
          //       break;
          //     }
          //   }
          // }
          
          // if(Obj[i].upload1 !=0 || Obj[i].upload2 !=0){
          //   this.RemoveCameraMarkerGroup()
          //   this.AddMarker(Obj[i],i,'CameraMarker')
          // }
        }
        //console.log(this.HistoryTracelatlngs)
        this.Historypolyline = L.polyline(this.HistoryTracelatlngs, {color: 'red'});
        this.Historypolyline.addTo(this.FMap)
      },
      //計算量測距離KM MI
      CalculateKmMi(){
        if(this.latlngs.length > 1){
          this.KmArr.push(Vue.prototype.$Global.distance(this.latlngs[this.latlngs.length-2].lat,this.latlngs[this.latlngs.length-2].lng,this.latlngs[this.latlngs.length-1].lat,this.latlngs[this.latlngs.length-1].lng,'K').toFixed(2))
          this.MiArr.push(Vue.prototype.$Global.distance(this.latlngs[this.latlngs.length-2].lat,this.latlngs[this.latlngs.length-2].lng,this.latlngs[this.latlngs.length-1].lat,this.latlngs[this.latlngs.length-1].lng,'N').toFixed(2))
          this.KmTotal.push(this.CaculateKmTotal().toFixed(2))
          this.MiTotal.push(this.CaculateMiTotal().toFixed(2))
        }else{
          this.KmArr.push('0.00')
          this.MiArr.push('0.00')
          this.KmTotal.push('0.00')
          this.MiTotal.push('0.00')
        }
      },
      //計算量測距離累積 MI
      CaculateMiTotal(){
        var MiTotalnum = 0
        for(var i=0;i<this.MiArr.length;i++){
          MiTotalnum = MiTotalnum + parseFloat(this.MiArr[i])
        }
        return MiTotalnum
      },
      //計算量測距離累積 KM
      CaculateKmTotal(){
        var KmTotalnum = 0
        for(var i=0;i<this.KmArr.length;i++){
          KmTotalnum = KmTotalnum +parseFloat(this.KmArr[i])
        }
        return KmTotalnum
      },
      //初始化polyline經緯度
      Removepolyline:function(){
        this.latlngs = []
      },
      //刪除polyline
      Deletepolyline:function(){
        this.FMap.removeLayer(this.polyline);
      },
      //刪除歷史軌跡polyline
      DeleteHistorypolyline:function(){
        this.FMap.removeLayer(this.Historypolyline);
      },
      //量測距離開關 建立 click 事件 或 關閉 click事件 
      //按鈕變色
      ClickMapDistance(){
        if(!this.PolySwitchClick){
          this.PolySwitchClick =true
          if(!this.MapclickListen){
            Vue.prototype.$("#mapdistance").addClass('Background-color-green')
            this.MapclickListen = true
            setTimeout(() => {
              this.AddMapclickListen()
              this.DistanceMarkerGroup = L.layerGroup().addTo(this.FMap)//建立DistancemarkerGroup
            }, 250);
          }else{
            Vue.prototype.$("#mapdistance").removeClass('Background-color-green')
            this.MapclickListen = false
            this.RemoveDistance()//刪除markerGroup
          }
          setTimeout(() => {
            this.PolySwitchClick =false
          }, 250);
        } 
      },
      //新增Geofence圖
      AddGeofence(Obj){
        this.Circles = L.featureGroup();
        this.Polygons = L.featureGroup();
        var circle;
        var polygon;
        this.CircleArr = []
        this.PolygonArr = []
        for(var i = 0 ; i < Obj.length;i++){
          switch (Obj[i].geoType) {
            case 'Circle':
              if(Obj[i].geoNodes){
                var geoNodesArr = Obj[i].geoNodes.split(';')      
                var lat = geoNodesArr[0].split(',')[0]
                var lng = geoNodesArr[0].split(',')[1]
                var mradius = geoNodesArr[1]*1000
                circle = L.circle([lat, lng], {radius: mradius})
                circle.bindPopup(Obj[i].zoneName,{closeOnClick: false,autoClose: false})
                circle.addTo(this.Circles)
                this.CircleArr.push(circle)
              }
              break;
            case 'Polygon':
              var latlngs = []
              if(Obj[i].geoNodes){
                var geoNodes = Obj[i].geoNodes.split(';')
                for(var j=0 ;j<geoNodes.length ; j++){
                  var lat = geoNodes[j].split(',')[0]
                  var lng = geoNodes[j].split(',')[1]
                  latlngs.push([lat, lng])
                }
                polygon = L.polygon(latlngs)
                polygon.bindPopup(Obj[i].zoneName,{closeOnClick: false,autoClose: false})
                polygon.addTo(this.Polygons);
                this.PolygonArr.push(polygon)
              }
              break;
          }
        }
        this.FMap.addLayer(this.Circles)
        this.FMap.addLayer(this.Polygons)
        // console.log(this.Polygons)
        // console.log(this.Circles)
        setTimeout(() => {
          if(this.CircleArr && this.CircleArr.length >0){
            for(var i = 0 ; i < this.CircleArr.length;i++){
              this.CircleArr[i].openPopup()
            }
          }
          if(this.PolygonArr && this.PolygonArr.length >0 ){
            for(var j = 0 ; j < this.PolygonArr.length;j++){
              this.PolygonArr[j].openPopup()
            }
          }
        }, 0);
      },
      //刪除Geofence圖
      RemoveGeofence(){
        if(this.FMap.hasLayer(this.Circles)){
          this.FMap.removeLayer(this.Circles)
          this.Circles = ''
        }
        if(this.FMap.hasLayer(this.Polygons)){
          this.FMap.removeLayer(this.Polygons)
          this.Polygons = ''
        }
      }
    }
  }
}




// WEBPACK FOOTER //
// ./src/LeafletMap.js